export function getAppColors(colorName: string) {
    return window.getComputedStyle(document.body).getPropertyValue(colorName)
}